import { Flex, Responsive } from '@radix-ui/themes';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  direction?: Responsive<"row" | "column" | "row-reverse" | "column-reverse">;
  justify?: Responsive<"start" | "center" | "end" | "between">
  style?: any;
}

const Container = ({
  children,
  className,
  style,
  direction = "row",
  justify = "center" }: Props) => {
  return (
    <Flex
      justify={justify}
      direction={direction}
      style={style}
      className={
        classNames(
          "sm:max-md:w-[96%]",
          "xl:max-w-screen-2xl",
          "mx-auto w-11/12",
          className
        )
      }
    >
      {children}
    </Flex>
  );
}

export default Container
